export const SAVE_DEALERSHIP_SELECTION = 'SAVE_DEALERSHIP_SELECTION';
